export enum sourceMailInformationEnum {
    MEDECIN = 'MEDECIN',
    PORTAIL = 'PORTAIL',
    SUIVILIVRAISON = 'SUIVI_LIVRAISON',
    DEPODOC = 'DEPO_DOC'
}
